module.exports = __webpack_public_path__ + "img/stop-hsa-signup-partab-3m-before-retire.4fd3beb.png";